import axios from '@/api';
import { ref } from 'vue';

export function useDelivery(campaignId: string) {
    const isLoading = ref(false);

    function deliver() {
        return axios
            .get(`/campaigns/${campaignId}/deliver_creatives`)
            .finally(() => {
                isLoading.value = false;
            });
    }

    return { deliver, isLoading };
}